import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { compose, bindActionCreators } from 'redux'
import { Button, Box } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

import warningIcon from 'assets/icons/warning.svg'
import * as directoryActions from 'actions/components/directory'
import * as formActions from 'actions/components/form'
import { Merchant } from 'models/merchant'
import CircularDatePicker from '../DatePicker/CircularDatePicker'
import CircularDatePickerENG from '../DatePicker/CircularDatePickerENG'
import TimeslotSelector from '../Selector/TimeslotSelector'
import DraggableDialog from './DraggableDialog'
import { redirect } from 'helpers/redirect'
import * as merchantConstants from 'constants/merchant'
import * as merchantActions from 'actions/components/merchant'

class Takeaway extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      availableTimeslots: [],
      availableDates: [],
    }
    this.minDate = null
    this.maxDate = null
  }

  componentDidMount = () => {
  }

  componentDidUpdate = (prevProps) => {
    const { merchant, getDateRange, getTimeRange } = this.props
    const isOpen = this.props.directory.display.takeaway

    if (!prevProps.directory.display.takeaway && this.props.directory.display.takeaway) {
      this.getTakeawayTimeSlots(merchant, getDateRange, getTimeRange)
      this.updateAvailableDates()
      this.updateTimeslots()
    }

    // Update takeaway timeslots when the selectedDate is changed.
    if (isOpen && prevProps.directory.selectedDate !== this.props.directory.selectedDate) {
      this.getTakeawayTimeSlots(merchant, getDateRange, getTimeRange)
      this.updateTimeslots()
    }
  }

  getTakeawayTimeSlots = async (merchant, getDateRange, getTimeRange) => {
    if (!merchant) return
    const selectedDate = this.props.directory.selectedDate
    if (this.state.availableDates.length === 0) {
      const dates = await getDateRange(merchant.id, 'takeaway', 0)
      this.setState({ availableDates: dates.dates.map(d => moment(d).format('YYYY-MM-DD')) })
      this.updateAvailableDates()
    }
    const formatedDate = selectedDate ? moment(selectedDate) : moment()
    const times = await getTimeRange(merchant.id, 'takeaway', 0, moment(formatedDate).format('YYYY-MM-DD'))
    this.setState({ availableTimeslots: times.map(t => moment(moment(selectedDate).format('YYYY-MM-DD') + t.time, 'YYYY-MM-DDHH:mm')) || [] })
    this.updateTimeslots()
  }

  updateAvailableDates = () => {
    const keys = Object.keys(this.state.availableDates)
    this.minDate = this.state.availableDates[keys[0]]
    this.maxDate = this.state.availableDates[keys[keys.length - 1]]
    if (this.props.directory.selectedDate !== this.minDate) {
      this.props.updateSelectedDate(this.minDate)
    }
  }

  updateTimeslots = () => {
    const defaultTimeslot = (this.state.availableTimeslots && this.state.availableTimeslots.length > 0) && moment(this.state.availableTimeslots[0], 'YYYY-MM-DDHH:mm').toISOString()
    if (this.props.directory.selectedTime !== defaultTimeslot) {
      this.props.updateSelectedTime(defaultTimeslot)
    }
  }

  renderOpeningInfo = () => {
    const { intl, classes, merchant } = this.props
    if (!merchant) return null

    const openingTitleText = merchant.setting.defaultClientLanguage === 'en' ? 'Takeaway' : intl.formatMessage({ id: 'directory.opening.subtitle.takeaway' })
    const openings = merchant.setting.directoryTakeawayTimeText || merchant.setting.directoryOpeningTimeText

    return (
      <div className={classes.info}>
        <div className={classes.icon}>
          <img src={warningIcon} alt='warning_icon' />
        </div>
        <div className={classes.textContent}>
          <p>{openingTitleText}</p>
          <p className={classes.openings}>{openings}</p>
        </div>
      </div>
    )
  }

  handleSubmit = async () => {
    const { directory, merchant, query } = this.props
    const shipping = directory.shipping
    const date = moment(directory.selectedDate).format('YYYY-MM-DD')
    const time = moment(directory.selectedTime).format('HH:mm')
    const datetime = moment(`${date} ${time}`).format()

    // Save selectedDateTime and selectedShippiing in form.
    this.props.setForm({ datetime, shipping })

    // Redirect to restaurant.
    redirect('takeaway', merchant, query, { datetime })
  }

  render () {
    const { intl, classes, merchant, directory } = this.props

    if (!merchant) return null

    const { takeaway } = directory.display
    const handleClose = () => this.props.updateDisplay('takeaway', false)
    const handleDateChange = (date) => this.props.updateSelectedDate(date)

    const dialogTitleText = merchant.setting.defaultClientLanguage === 'en' ? 'Please Select Your Time' : intl.formatMessage({ id: 'directory.dateTimePicker.title.takeaway' })
    const datePickerTitleText = merchant.setting.defaultClientLanguage === 'en' ? 'Select A Date' : intl.formatMessage({ id: 'directory.dateTimePicker.selectDate.takeaway' })
    const timePickerTitleText = merchant.setting.defaultClientLanguage === 'en' ? 'Select A Time' : intl.formatMessage({ id: 'directory.dateTimePicker.selectTime.takeaway' })
    const submitText = merchant.setting.defaultClientLanguage === 'en' ? 'Make Your Order' : intl.formatMessage({ id: 'directory.dateTimePicker.submit' })

    return (
      <DraggableDialog
        open={takeaway}
        onClose={handleClose}
      >
        <p className={classes.title}>{dialogTitleText}</p>
        {this.renderOpeningInfo()}

        <section className={classes.section}>
          <p>{datePickerTitleText}</p>
          {
            merchant.setting.defaultClientLanguage === 'en'
              ? <CircularDatePickerENG
                dates={this.state.availableDates}
                handleDateChange={handleDateChange}
              />
              : <CircularDatePicker
                dates={this.state.availableDates}
                handleDateChange={handleDateChange}
              />
          }
        </section>

        <section className={classes.section}>
          <p>{timePickerTitleText}</p>
          <TimeslotSelector deliveryType={merchantConstants.DELIVERY_TYPE_TAKEAWAY} timeslots={this.state.availableTimeslots} />
        </section>

        <Box display='flex' justifyContent='center' alignItems='center' mt='24px' mb='24px'>
          <Button
            disableElevation
            className={classes.submitButton}
            color='primary'
            variant='contained'
            onClick={this.handleSubmit}
          >
            {submitText}
          </Button>
        </Box>
      </DraggableDialog>
    )
  }
}

const styles = {
  title: {
    margin: 0,
    padding: '8px 24px 8px 24px',
    fontWeight: 500,
    fontSize: 22,
  },
  info: {
    display: 'flex',
    '& p': {
      margin: 0, // remove default margin
      fontSize: 15,
      fontFamily: 'Roboto',
      lineHeight: '21px', // the height of the icon.
      color: '#95292C',
    },
  },
  icon: {
    height: 21,
    width: 21,
    display: 'grid',
    placeItems: 'center',
    marginRight: 8,
  },
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr auto auto',
    gridGap: '4px',
    '& > p': {
      whiteSpace: 'pre',
    },
  },
  gridItemFullwidth: {
    gridColumn: '1 / span 3',
  },
  textContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  section: {
    marginTop: 24,
    '& > p': {
      margin: 0, // remove default margin
      fontSize: 16,
      color: '#8A8A8A',
    },
  },
  submitButton: {
    alignSelf: 'center',
    color: '#ffffff',
    width: 220,
    height: 40,
    fontSize: 18,
    fontWeight: 300,
    borderRadius: 10,
  },
  underline: {
    borderBottom: '2px solid #EBBD3F',
  },
  openings: {
    whiteSpace: 'pre-line',
    wordBreak: 'break-all',
  },
}

const mapStateToProps = (state) => {
  return {
    merchant: state.merchant,
    directory: state.directory,
    query: state.query,
  }
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(directoryActions, dispatch),
  ...bindActionCreators(formActions, dispatch),
  ...bindActionCreators(merchantActions, dispatch),
})

export default withRouter(
  compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles),
    injectIntl,
  )(Takeaway),
)



// WEBPACK FOOTER //
// ./src/components/scenes/DirectoryPage/Dialog/Takeaway.jsx